import React from 'react'
import { graphql, compose } from 'react-apollo'
import { dataUnready } from '~/lib/helpers/dataUnready'
import { QueryAllTermOfServiceAppsInfo } from '~/queries/public.gql'
import TopicLinks from '~/components/shared/TopicLinks'
import PropTypes from 'prop-types'

function Applications ({ data, scpApp: selectedAppId }) {
  const { unready, cms_allTermOfServiceTopics: scpApps } = dataUnready(data, 'cms_allTermOfServiceTopics')
  let results = null

  if (unready) {
    results = unready
  } else if (scpApps.length === 0) {
    results = <div className='d-none d-md-block'>No SCP Applications</div>
  } else {
    const appsInfo = scpApps.map(app => {
      return {
        name: app.name,
        href: '/tos/app/[id]',
        as: `/tos/app/${app.id}`,
        isActive: app.id === selectedAppId
      }
    })

    results = (
      <TopicLinks
        title='SCP Applications'
        modalTitle='SCP Applications'
        topics={appsInfo}
        defaultButtonText='Select an application...'
      />
    )
  }

  return results
}

Applications.propTypes = {
  data: PropTypes.object.isRequired,
  scpApp: PropTypes.string
}

const withAllTermOfServiceApps = graphql(QueryAllTermOfServiceAppsInfo)

export default compose(
  withAllTermOfServiceApps
)(Applications)
